import { render, staticRenderFns } from "./HasDamagesQuestion.vue?vue&type=template&id=5f01f840&scoped=true"
import script from "./HasDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./HasDamagesQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f01f840",
  null
  
)

export default component.exports